export const test = {
	XWEATHER_ID: 'H0IzYsAB1s2tyX5Mc2v0x',
	API_ASSETS: 'https://api.lxalert.us-test.ltg.vaisala.net',
	API_IMPACTS: 'https://api.lxalert.us-test.ltg.vaisala.net/api',
	API_ANALYZE: 'https://api.lxalert.us-test.ltg.vaisala.net',
	API_DEVICES: 'https://api.test.sampo.vaisala.net/api/device',
	API_DEVICE_METRICS: 'https://api.test.sampo.vaisala.net/api/device-metric-aggregation',
	API_MEASUREMENTS: 'https://api.test.sampo.vaisala.net/api/query-measurements',
	API_MEASUREMENT_ALERTS: 'https://config-api.test.alert-service.auroral.vaisala.net',
	API_CORRECTIONS: 'https://api.test.sampo.vaisala.net/api/measurement',
	API_AURORAL: 'https://api.test.auroral.vaisala.net',
	API_TEST_SAMPO: 'https://api.test.sampo.vaisala.net',
	API_INSIGHT: 'https://insight-api-test.auroral.vaisala.net',
	API_PROTECTIONS: 'https://app-sync.us-test.ltg.vaisala.net/v2/protection',
	API_LIGHTNING: 'https://api.lxalert.us-test.ltg.vaisala.net',
	API_WIND_PROTECTIONS: 'https://app-sync.us-test.ltg.vaisala.net/protections',
	API_ALERTS: 'https://app-sync.us-test.ltg.vaisala.net/v2/alert-event',
	API_ALERTS_GATEWAY: 'https://api.lxalert.us-test.ltg.vaisala.net/api/v3/alert-event',
	API_WIND_ALERTS: 'https://app-sync.us-test.ltg.vaisala.net/alerts',
	API_LIGHTNING_REPORTS: 'https://app-sync.us-test.ltg.vaisala.net/analyze',
	AUTH_DOMAIN: 'https://auth-eu.auroral.vaisala.net',
	OBSERVE_WS: 'wss://ws-api.test.sampo.vaisala.net',
	LD_CLIENTSIDE_ID: '67befe550811eb09a90bcbd9',
	LD_FALLBACK_PROXY_URL: 'https://insight.test.auroral.vaisala.net/ld',
	LTG_RT_GRID_ANIMATED: 'https://geopg.us-test.ltg.vaisala.net/proxy/5tc9f8im22j9nugpdc8brqb13b/wmts',
	LTG_RT_GRID_30_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/1r3gkik82p8umlveiihuj1kqq1/wmts',
	LTG_RT_GRID_CG_30_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/7mvgjhl4adj49gka7mt9qpkuot/wmts',
	LTG_RT_GRID_CG_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/6f0njqsl9c50vsnr0i79p4luua/wmts',
	LTG_RT_GRID_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/4gmsedevv9aus879002spjld2b/wmts',
	LTG_RT_POINT_ANIMATED: 'https://geopg.us-test.ltg.vaisala.net/rt-merge/{z}/{x}/{y}',
	LTG_RT_POINT_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/4d4gp57861blrtt27rc0ro4511/wmts',
	LTG_CONTOUR_LAYER: 'https://interactive-lightning-map.tsmh-dev.vaisala.io',
	LTZ_POLYGON_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/5ki6renv6s1qu9al3g7ta3df94/wmts',
	LTZ_CENTROID_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/7pi4c5d4dcu746hm1nr3trqve3/wmts',
	LTZ_VELOCITY_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/29n4iok8o2nt7hqgtb6gdladp2/wmts',
	LTZ_V2_POLYGON_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/fw2r3slpznh50e52chwftaghzc/wmts',
	LTZ_V2_CENTROID_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/l3kujlpq0b2erpoawdetzdfnup/wmts',
	LTZ_V2_VELOCITY_LAYER: 'https://geopg.us-test.ltg.vaisala.net/proxy/qocbm34azdf84r7tcm3xml5hfx/wmts',
	WEB_RELAY_URL: 'webrelay.us-test.ltg.vaisala.net',
	INTERCOM_APP_ID: 'ov4pn47f',
	AUTH_CLIENT_ID: '8zZTkOubcnLFrt1Ykx53S94md6YzUnl8',
	AUTH_AUDIENCE: 'https://api.test.auroral.vaisala.net/',
}
export type Env = typeof test

export const demo = { ...test, LD_FALLBACK_PROXY_URL: 'https://insight-demo.test.auroral.vaisala.net/ld' }

export const sit = {
	XWEATHER_ID: 'H0IzYsAB1s2tyX5Mc2v0x',
	API_ASSETS: 'https://api.lxalert.eu-test.ltg.vaisala.net',
	API_IMPACTS: 'https://api.lxalert.eu-test.ltg.vaisala.net/api',
	API_ANALYZE: 'https://api.lxalert.eu-test.ltg.vaisala.net',
	API_DEVICES: 'https://api.platform.auroral.vaisala.net/api/device',
	API_DEVICE_METRICS: 'https://api.platform.auroral.vaisala.net/api/device-metric-aggregation',
	API_MEASUREMENTS: 'https://api.platform.auroral.vaisala.net/api/query-measurements',
	API_MEASUREMENT_ALERTS: 'https://config-api.sit.alert-service.auroral.vaisala.net',
	API_CORRECTIONS: 'https://api.platform.auroral.vaisala.net/api/measurement',
	API_AURORAL: 'https://api.platform.auroral.vaisala.net',
	API_TEST_SAMPO: 'https://api.test.sampo.vaisala.net',
	API_INSIGHT: 'https://insight-api.platform.auroral.vaisala.net',
	API_PROTECTIONS: 'https://app-sync.eu-test.ltg.vaisala.net/v2/protection',
	API_LIGHTNING: 'https://api.lxalert.eu-test.ltg.vaisala.net',
	API_WIND_PROTECTIONS: 'https://app-sync.eu-test.ltg.vaisala.net/protections',
	API_ALERTS: 'https://app-sync.eu-test.ltg.vaisala.net/v2/alert-event',
	API_ALERTS_GATEWAY: 'https://api.lxalert.eu-test.ltg.vaisala.net/api/v3/alert-event',
	API_WIND_ALERTS: 'https://app-sync.eu-test.ltg.vaisala.net/alerts',
	API_LIGHTNING_REPORTS: 'https://app-sync.eu-test.ltg.vaisala.net/analyze',
	AUTH_DOMAIN: 'https://auth-eu.auroral.vaisala.net',
	OBSERVE_WS: 'wss://ws-api.platform.auroral.vaisala.net',
	LD_CLIENTSIDE_ID: '67befe6f79402009dc95ebdc',
	LD_FALLBACK_PROXY_URL: 'https://insight.platform.auroral.vaisala.net/ld',
	LTG_RT_GRID_ANIMATED: 'https://geopg.eu-test.ltg.vaisala.net/proxy/5tc9f8im22j9nugpdc8brqb13b/wmts',
	LTG_RT_GRID_30_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/1r3gkik82p8umlveiihuj1kqq1/wmts',
	LTG_RT_GRID_CG_30_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/7mvgjhl4adj49gka7mt9qpkuot/wmts',
	LTG_RT_GRID_CG_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/6f0njqsl9c50vsnr0i79p4luua/wmts',
	LTG_RT_GRID_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/4gmsedevv9aus879002spjld2b/wmts',
	LTG_RT_POINT_ANIMATED: 'https://geopg.eu-test.ltg.vaisala.net/rt-merge/{z}/{x}/{y}',
	LTG_RT_POINT_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/4d4gp57861blrtt27rc0ro4511/wmts',
	LTG_CONTOUR_LAYER: 'https://interactive-lightning-map.vaisala.com',
	LTZ_POLYGON_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/5ki6renv6s1qu9al3g7ta3df94/wmts',
	LTZ_CENTROID_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/7pi4c5d4dcu746hm1nr3trqve3/wmts',
	LTZ_VELOCITY_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/29n4iok8o2nt7hqgtb6gdladp2/wmts',
	LTZ_V2_POLYGON_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/fw2r3slpznh50e52chwftaghzc/wmts',
	LTZ_V2_CENTROID_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/l3kujlpq0b2erpoawdetzdfnup/wmts',
	LTZ_V2_VELOCITY_LAYER: 'https://geopg.eu-test.ltg.vaisala.net/proxy/qocbm34azdf84r7tcm3xml5hfx/wmts',
	WEB_RELAY_URL: 'webrelay.eu-test.ltg.vaisala.net',
	INTERCOM_APP_ID: 'ov4pn47f',
	AUTH_CLIENT_ID: 'NcfScEzhACOVNGFij9ND4iKT9BrnfMvA',
	AUTH_AUDIENCE: 'https://api.platform.auroral.vaisala.net/',
} satisfies Env

export const prodSandbox = { ...sit, LD_FALLBACK_PROXY_URL: 'https://prod-sandbox.platform.auroral.vaisala.net/ld' }

export const prodEU = {
	XWEATHER_ID: 'H0IzYsAB1s2tyX5Mc2v0x',
	API_ASSETS: 'https://api.lxalert.eu-prod.ltg.platform.xweather.com',
	API_IMPACTS: 'https://api.lxalert.eu-prod.ltg.platform.xweather.com/api',
	API_ANALYZE: 'https://api.lxalert.eu-prod.ltg.platform.xweather.com',
	API_DEVICES: 'https://api.eu.platform.xweather.com/api/device',
	API_DEVICE_METRICS: 'https://api.eu.platform.xweather.com/api/device-metric-aggregation',
	API_MEASUREMENTS: 'https://api.eu.platform.xweather.com/api/query-measurements',
	API_MEASUREMENT_ALERTS: 'https://config-api.alert-service.platform.xweather.com',
	API_CORRECTIONS: 'https://api.eu.platform.xweather.com/api/measurement',
	API_AURORAL: 'https://api.eu.platform.xweather.com',
	API_TEST_SAMPO: 'https://api.test.sampo.vaisala.net',
	API_INSIGHT: 'https://api.eu.insight.xweather.com',
	API_PROTECTIONS: 'https://app-sync.eu-prod.ltg.platform.xweather.com/v2/protection',
	API_LIGHTNING: 'https://api.lxalert.eu-prod.ltg.platform.xweather.com',
	API_WIND_PROTECTIONS: 'https://app-sync.eu-prod.ltg.platform.xweather.com/protections',
	API_ALERTS: 'https://app-sync.eu-prod.ltg.platform.xweather.com/v2/alert-event',
	API_ALERTS_GATEWAY: 'https://api.lxalert.eu-prod.ltg.platform.xweather.com/api/v3/alert-event',
	API_WIND_ALERTS: 'https://app-sync.eu-prod.ltg.platform.xweather.com/alerts',
	API_LIGHTNING_REPORTS: 'https://app-sync.eu-prod.ltg.platform.xweather.com/analyze',
	AUTH_DOMAIN: 'https://auth.eu.platform.xweather.com',
	OBSERVE_WS: 'wss://ws-api.eu.platform.xweather.com',
	LD_CLIENTSIDE_ID: '67befe550811eb09a90bcbda',
	LD_FALLBACK_PROXY_URL: 'https://eu.insight.xweather.com/ld',
	LTG_RT_GRID_ANIMATED: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/2deu0g30t9om4iu7a4dtvd3dkl/wmts',
	LTG_RT_GRID_30_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/1r3gkik82p8umlveiihuj1kqq1/wmts',
	LTG_RT_GRID_CG_30_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/7mvgjhl4adj49gka7mt9qpkuot/wmts',
	LTG_RT_GRID_CG_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/6f0njqsl9c50vsnr0i79p4luua/wmts',
	LTG_RT_GRID_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/4gmsedevv9aus879002spjld2b/wmts',
	LTG_RT_POINT_ANIMATED: 'https://geopg.eu-prod.ltg.platform.xweather.com/rt-merge/{z}/{x}/{y}',
	LTG_RT_POINT_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/4d4gp57861blrtt27rc0ro4511/wmts',
	LTG_CONTOUR_LAYER: 'https://interactive-lightning-map.vaisala.com',
	LTZ_POLYGON_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/n75yrwhzbkudmujqf2rk5s9dnb/wmts',
	LTZ_CENTROID_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/tfigz9tec5ei2kvo2ekdzf3fxa/wmts',
	LTZ_VELOCITY_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/2wcsxrepqq7wgtg47tffk75md4/wmts',
	LTZ_V2_POLYGON_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/fw2r3slpznh50e52chwftaghzc/wmts',
	LTZ_V2_CENTROID_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/l3kujlpq0b2erpoawdetzdfnup/wmts',
	LTZ_V2_VELOCITY_LAYER: 'https://geopg.eu-prod.ltg.platform.xweather.com/proxy/qocbm34azdf84r7tcm3xml5hfx/wmts',
	WEB_RELAY_URL: 'webrelay.eu-prod.ltg.platform.xweather.com',
	INTERCOM_APP_ID: 'ov4pn47f',
	AUTH_CLIENT_ID: '18GzHZ2zv3B5kXV0QA9mm3AWiOV4dHwW',
	AUTH_AUDIENCE: 'https://api.eu.platform.xweather.com/',
} satisfies Env

export const prodUS = {
	XWEATHER_ID: 'H0IzYsAB1s2tyX5Mc2v0x',
	API_ASSETS: 'https://api.lxalert.us-prod.ltg.platform.xweather.com',
	API_IMPACTS: 'https://api.lxalert.us-prod.ltg.platform.xweather.com/api',
	API_ANALYZE: 'https://api.lxalert.us-prod.ltg.platform.xweather.com',
	API_DEVICES: 'https://api.us.platform.xweather.com/api/device',
	API_DEVICE_METRICS: 'https://api.us.platform.xweather.com/api/device-metric-aggregation',
	API_MEASUREMENTS: 'https://api.us.platform.xweather.com/api/query-measurements',
	API_MEASUREMENT_ALERTS: 'https://us-config-api.alert-service.platform.xweather.com',
	API_CORRECTIONS: 'https://api.us.platform.xweather.com/api/measurement',
	API_AURORAL: 'https://api.us.platform.xweather.com',
	API_TEST_SAMPO: 'https://api.test.sampo.vaisala.net',
	API_INSIGHT: 'https://api.us.insight.xweather.com',
	API_PROTECTIONS: 'https://app-sync.us-prod.ltg.platform.xweather.com/v2/protection',
	API_LIGHTNING: 'https://api.lxalert.us-prod.ltg.platform.xweather.com',
	API_WIND_PROTECTIONS: 'https://app-sync.us-prod.ltg.platform.xweather.com/protections',
	API_ALERTS: 'https://app-sync.us-prod.ltg.platform.xweather.com/v2/alert-event',
	API_ALERTS_GATEWAY: 'https://api.lxalert.us-prod.ltg.platform.xweather.com/api/v3/alert-event',
	API_WIND_ALERTS: 'https://app-sync.us-prod.ltg.platform.xweather.com/alerts',
	API_LIGHTNING_REPORTS: 'https://app-sync.us-prod.ltg.platform.xweather.com/analyze',
	AUTH_DOMAIN: 'https://auth.us.platform.xweather.com',
	OBSERVE_WS: 'wss://ws-api.us.platform.xweather.com',
	LD_CLIENTSIDE_ID: '67befe550811eb09a90bcbda',
	LD_FALLBACK_PROXY_URL: 'https://us.insight.xweather.com/ld',
	LTG_RT_GRID_ANIMATED: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/2deu0g30t9om4iu7a4dtvd3dkl/wmts',
	LTG_RT_GRID_30_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/1r3gkik82p8umlveiihuj1kqq1/wmts',
	LTG_RT_GRID_CG_30_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/7mvgjhl4adj49gka7mt9qpkuot/wmts',
	LTG_RT_GRID_CG_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/6f0njqsl9c50vsnr0i79p4luua/wmts',
	LTG_RT_GRID_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/4gmsedevv9aus879002spjld2b/wmts',
	LTG_RT_POINT_ANIMATED: 'https://geopg.us-prod.ltg.platform.xweather.com/rt-merge/{z}/{x}/{y}',
	LTG_RT_POINT_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/4d4gp57861blrtt27rc0ro4511/wmts',
	LTG_CONTOUR_LAYER: 'https://interactive-lightning-map.vaisala.com',
	LTZ_POLYGON_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/n75yrwhzbkudmujqf2rk5s9dnb/wmts',
	LTZ_CENTROID_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/tfigz9tec5ei2kvo2ekdzf3fxa/wmts',
	LTZ_VELOCITY_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/2wcsxrepqq7wgtg47tffk75md4/wmts',
	LTZ_V2_POLYGON_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/fw2r3slpznh50e52chwftaghzc/wmts',
	LTZ_V2_CENTROID_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/l3kujlpq0b2erpoawdetzdfnup/wmts',
	LTZ_V2_VELOCITY_LAYER: 'https://geopg.us-prod.ltg.platform.xweather.com/proxy/qocbm34azdf84r7tcm3xml5hfx/wmts',
	WEB_RELAY_URL: 'webrelay.us-prod.ltg.platform.xweather.com',
	INTERCOM_APP_ID: 'ov4pn47f',
	AUTH_CLIENT_ID: 'hMbLUEJJVNFpbbzHZvfW0Vt2Iu9j2W0Z',
	AUTH_AUDIENCE: 'https://api.us.platform.xweather.com/',
} satisfies Env

export const dev = {
	XWEATHER_ID: 'H0IzYsAB1s2tyX5Mc2v0x',
	API_ASSETS: 'https://api.lxalert.eu-dev.ltg.vaisala.net',
	API_IMPACTS: 'https://api.lxalert.eu-dev.ltg.vaisala.net/api',
	API_ANALYZE: 'https://api.lxalert.eu-dev.ltg.vaisala.net',
	API_DEVICES: 'https://api.dev-1.sampo.vaisala.net/api/device',
	API_DEVICE_METRICS: 'https://api.dev-1.sampo.vaisala.net/api/device-metric-aggregation',
	API_MEASUREMENTS: 'https://api.dev-1.sampo.vaisala.net/api/query-measurements',
	API_MEASUREMENT_ALERTS: 'https://config-api.dev-1.alert-service.auroral.vaisala.net',
	API_CORRECTIONS: 'https://api.dev-1.sampo.vaisala.net/api/measurement',
	API_AURORAL: 'https://api.dev.auroral.vaisala.net',
	API_TEST_SAMPO: 'https://api.test.sampo.vaisala.net',
	API_INSIGHT: 'https://insight-api.dev.auroral.vaisala.net',
	API_PROTECTIONS: 'https://app-sync.eu-dev.ltg.vaisala.net/v2/protection',
	API_LIGHTNING: 'https://api.lxalert.eu-dev.ltg.vaisala.net',
	API_WIND_PROTECTIONS: 'https://app-sync.eu-dev.ltg.vaisala.net/protections',
	API_ALERTS: 'https://app-sync.eu-dev.ltg.vaisala.net/v2/alert-event',
	API_ALERTS_GATEWAY: 'https://api.lxalert.eu-dev.ltg.vaisala.net/api/v3/alert-event',
	API_WIND_ALERTS: 'https://app-sync.eu-dev.ltg.vaisala.net/alerts',
	API_LIGHTNING_REPORTS: 'https://app-sync.eu-dev.ltg.vaisala.net/analyze',
	AUTH_DOMAIN: 'https://auth-eu.auroral.vaisala.net',
	OBSERVE_WS: 'wss://ws-api.dev-1.sampo.vaisala.net',
	LD_CLIENTSIDE_ID: '67befe550811eb09a90bcbd9',
	LD_FALLBACK_PROXY_URL: 'https://insight.test.auroral.vaisala.net/ld',
	LTG_RT_GRID_ANIMATED: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/4o9ma8p3t2fq2epuoaec2af4pd/wmts',
	LTG_RT_GRID_30_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/1r3gkik82p8umlveiihuj1kqq1/wmts',
	LTG_RT_GRID_CG_30_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/7mvgjhl4adj49gka7mt9qpkuot/wmts',
	LTG_RT_GRID_CG_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/6f0njqsl9c50vsnr0i79p4luua/wmts',
	LTG_RT_GRID_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/4gmsedevv9aus879002spjld2b/wmts',
	LTG_RT_POINT_ANIMATED: 'https://geopg.eu-dev.ltg.vaisala.net/rt-merge/{z}/{x}/{y}',
	LTG_RT_POINT_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/4d4gp57861blrtt27rc0ro4511/wmts',
	LTG_CONTOUR_LAYER: 'https://interactive-lightning-map.vaisala.com',
	LTZ_POLYGON_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/5ki6renv6u1qu9al3gbta3df9e/wmts',
	LTZ_CENTROID_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/7pi4c5d4dcuu46hm1ni3trqve5/wmts',
	LTZ_VELOCITY_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/29n4ioj8o2nt7hqgtbrgdladp1/wmts',
	LTZ_V2_POLYGON_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/fw2r3slpznh50e52chwftaghzc/wmts',
	LTZ_V2_CENTROID_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/l3kujlpq0b2erpoawdetzdfnup/wmts',
	LTZ_V2_VELOCITY_LAYER: 'https://geopg.eu-dev.ltg.vaisala.net/proxy/qocbm34azdf84r7tcm3xml5hfx/wmts',
	WEB_RELAY_URL: 'webrelay.eu-dev.ltg.vaisala.net',
	INTERCOM_APP_ID: 'ov4pn47f',
	AUTH_CLIENT_ID: 'vi8jajsyIrLFJh2Fk9XTWpkuH9n7X2D6',
	AUTH_AUDIENCE: 'https://api.dev.auroral.vaisala.net/',
} satisfies Env
